const en = {
  COMMON: {
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    ADD: 'Add',
    SAVE: 'Save',
    EDIT: 'Edit',
    DELETE: 'Delete',
    SETTINGS: 'Settings',
    NONE: 'None',
    DUPLICATE: 'Duplicate',
    COPY_OF_TASK: 'Copy of {{ title }}',
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
    MON: 'Mon',
    TUE: 'Tue',
    WED: 'Wed',
    THU: 'Thu',
    FRI: 'Fri',
    SAT: 'Sat',
    SUN: 'Sun',
    TODAY: 'Today',
    CUT: 'Cut',
    COPY: 'Copy',
    PASTE: 'Paste',
  },
  CONFIRMATION_DIALOG: {
    CONFIRM: 'Confirm',
    TITLE_LEAVE_PROGRESS: 'Leave progress?',
    LEAVE_PROGRESS: 'Please confirm that you want to abandon your progress.\n\nOtherwise cancel.',
    TITLE_DELETE_TASK: 'Delete task',
    DELETE_TASK: 'Please confirm that you want to delete task\n"{{ name }}".\n\nThis operation cannot be reverted.',
    TITLE_DELETE_MULTIPLE_TASKS: 'Delete multiple tasks',
    DELETE_MULTIPLE_TASKS: 'Please confirm that you want to delete {{ count }} tasks.\n\nThis operation cannot be reverted.',
  },
  SETTINGS_DIALOG: {
    MANAGE_CATEGORIES: 'Manage categories',
    NEW_CATEGORY: 'New category',
    ADD_CATEGORY: 'Add category',
    BOARD_SETTINGS: 'Board settings',
    WEEKEND_DISPLAY: 'Weekend display',
    NO_WEEKEND: 'No weekend',
    SATURDAY_ONLY: 'Saturday only',
    FULL_WEEKEND: 'Full weekend',
    FIRST_DAY_OF_WEEK: 'First day of the week',
    DISABLE_TIME_CHECK: 'Disable time check',
    DISABLE_TIME_CHECK_INFO: 'Checking this option will turn off calculating total hours in a day, as well as any limits. Progress bar will be hidden too.',
    DAY_TARGET: 'Target hours per day',
    DAY_TARGET_INFO: 'Amount of expected hours in a day. This value means 100% in the progress bar.',
    DAY_LIMIT: 'Limit of hours per day',
    DAY_LIMIT_INFO: 'Maximum acceptable amount of hours logged. If this number is to be exceeded, creating new tasks or pasting and dropping tasks will not be available.',
    HOURS_SUFFIX: 'hours',
    LANGUAGE: 'Language',
    THEME: 'Theme',
    CONDENSED_VIEW: 'Condensed view',
    YES: 'Yes',
    NO: 'No',
  },
  TASK_DIALOG: {
    ADD_TASK: 'Add task',
    VIEW_TASK: 'View task',
    EDIT_TASK: 'Edit task',
    TASK_NAME_PLACEHOLDER: 'Task name',
    TASK_DESCRIPTION_PLACEHOLDER: 'Task description',
    TASK_CATEGORIES_PLACEHOLDER: 'Categories',
    TASK_DATE_PLACEHOLDER: 'When?',
    TASK_DURATION_PLACEHOLDER: '"1h", "30m", "2h 15m" etc.',
    TASK_NAME_TITLE: 'Task name',
    TASK_DESCRIPTION_TITLE: 'Task description',
    TASK_CATEGORIES_TITLE: 'Categories',
    TASK_DATE_TITLE: 'Date',
    TASK_DURATION_TITLE: 'Duration',
    CANNOT_DUPLICATE_BECAUSE_OF_LIMIT: 'Cannot duplicate the task because it would exceed the {{ limit }}h limit.',
  },
  ERROR: {
    DAY_LIMIT_EXCEEDED: 'Cannot log more than {{ limit }} hours in a day.\nCurrent: {{ current }}.',
  },
  THEME: {
    LIGHT_BLUE: 'Light (blue)',
    LIGHT_PURPLE: 'Light (purple)',
    DARK_GREEN: 'Dark (green)',
    DARK_YELLOW: 'Dark (yellow)',
    DARK_TEAL: 'Dark (teal)',
  },
  COLUMN: {
    CANNOT_DROP_BECAUSE_OF_LIMIT: 'Cannot drop the task to this column because it would exceed the {{ limit }}h limit.',
    CANNOT_PASTE_BECAUSE_OF_LIMIT: 'Cannot paste the task because it would exceed the {{ limit }}h limit.',
    NOTHING_TO_PASTE: 'There is no task in the clipboard.',
  },
  FILTERS: {
    CLEAR: 'Clear',
    FILTER_CATEGORIES: 'Filter categories',
    SELECT_CATEGORIES_PLACEHOLDER: 'Select categories...',
    ANY_OR_EVERY: 'Any or every',
    ANY_OR_EVERY_TOOLTIP: 'Should tasks contain any or every selected category?',
    ANY: 'Any',
    EVERY: 'Every',
    SAVE_FILTERS: 'Save filters',
    SAVE_FILTERS_EXPLANATION: 'This will save current filters and load them when you come back.',
    SAVE_AS_DEFAULT: 'Save as default',
    RESTORE_DEFAULT: 'Restore default',
    ALREADY_DEFAULT_TOOLTIP: 'Current filters are already default ones.'
  },
  HEADER: {
    CURRENT_FILTERS: 'Currently showing tasks with categories',
    AND: 'and',
    OR: 'or',
    TOTAL_TIME_THIS_WEEK: 'Total time this week',
    X_MORE: '{{ x }} more',
  }
};

export default en;